export default "__VITE_ASSET__7e72d639__"